module.exports = __webpack_public_path__ + "static/media/header-12.0b9e5d25.png";